/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function AcctProgressView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '20px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {' '}
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '14px',
          flexWrap: 'wrap',
          paddingBottom: '14px',
          borderBottom: '1px solid var(--l6)',
        }}
      >
        {' '}
        <div style={{ flex: '1', minWidth: '240px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <i className="ph ph-trophy" style={{ fontSize: '17px', color: 'var(--amb)' }}></i>
            <span style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '-0.01em' }}>
              Accounts Progress
            </span>
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
            Prop firm challenge tracking and rule compliance
          </div>{' '}
        </div>{' '}
        {m.apMulti ? (
          <>
            {' '}
            <div
              style={{
                display: 'flex',
                gap: '3px',
                padding: '3px',
                borderRadius: '12px',
                border: '1px solid var(--l8)',
                background: 'var(--l3)',
              }}
            >
              {' '}
              {(m.apAccts ?? []).map((a, i144) => (
                <Fragment key={i144}>
                  {' '}
                  <button
                    onClick={a?.go}
                    aria-label={`Show ${dc.s(a?.label)}`}
                    style={dc.css(
                      `padding:5px 12px;border-radius:9px;border:1px solid ${dc.s(a?.bd)};background:${dc.s(a?.bg)};color:${dc.s(a?.fg)};font-size:10.5px;font-weight:500;cursor:pointer;white-space:nowrap`,
                    )}
                  >
                    {dc.t(a?.label)}
                  </button>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      <div
        style={dc.css(
          `background:${dc.s(m.apHeroBg)};border:1px solid ${dc.s(m.apHeroBd)};box-shadow:var(--shadow-card);border-radius:18px;padding:20px 22px`,
        )}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', flexWrap: 'wrap' }}>
          {' '}
          <span
            style={dc.css(
              `width:38px;height:38px;border-radius:12px;background:${dc.s(m.apHeroTileBg)};display:flex;align-items:center;justify-content:center;flex:none`,
            )}
          >
            <i
              className={`ph ${dc.s(m.apHeroIcon)}`}
              style={dc.css(`font-size:18px;color:${dc.s(m.apHeroIconFg)}`)}
            ></i>
          </span>{' '}
          <div style={{ flex: '1', minWidth: '180px' }}>
            {' '}
            <div style={{ fontSize: '14px', fontWeight: '600', letterSpacing: '-0.01em' }}>
              {dc.t(m.apName)}
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '7px', marginTop: '4px' }}>
              {' '}
              <span
                style={{
                  fontSize: '9.5px',
                  padding: '2px 8px',
                  borderRadius: '99px',
                  border: '1px solid var(--l10)',
                  color: 'var(--muted)',
                }}
              >
                {dc.t(m.apBroker)}
              </span>{' '}
              <span
                style={dc.css(
                  `font-size:9.5px;font-weight:600;letter-spacing:0.04em;padding:2px 8px;border-radius:99px;background:${dc.s(m.apStatusBg)};color:${dc.s(m.apStatusFg)}`,
                )}
              >
                {dc.t(m.apStatus)}
              </span>{' '}
            </div>{' '}
          </div>{' '}
          {m.apShowDays ? (
            <>
              {' '}
              <span
                style={dc.css(
                  `display:inline-flex;align-items:center;gap:6px;font-size:11px;font-weight:600;padding:6px 12px;border-radius:9px;border:1px solid ${dc.s(m.apDaysBd)};color:${dc.s(m.apDaysFg)};flex:none`,
                )}
              >
                <i className={`ph ${dc.s(m.apDaysIcon)}`} style={{ fontSize: '12px' }}></i>
                {dc.t(m.apDaysLeft)}
              </span>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,170px),1fr))',
            gap: '16px',
            marginTop: '20px',
          }}
        >
          {' '}
          {(m.apHeroMetrics ?? []).map((m, i145) => (
            <Fragment key={i145}>
              {' '}
              <div>
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  {dc.t(m?.label)}
                </div>
                <div
                  style={dc.css(
                    `font-size:17px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(m?.c)};margin-top:3px;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m?.value)}
                </div>
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  {dc.t(m?.sub)}
                </div>
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ marginTop: '20px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '11px' }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', color: 'var(--muted)' }}>
              <i className="ph ph-target" style={{ fontSize: '12px' }}></i>Profit Target Progress
            </span>
            <div style={{ flex: '1' }}></div>
            <span
              style={dc.css(`font-weight:600;color:${dc.s(m.apProfitFg)};font-variant-numeric:tabular-nums`)}
            >
              {dc.t(m.apProfitPct)}
            </span>
          </div>{' '}
          <div
            style={{
              position: 'relative',
              height: '12px',
              borderRadius: '99px',
              background: 'var(--l6)',
              overflow: 'hidden',
              marginTop: '8px',
            }}
          >
            {' '}
            <div
              style={dc.css(
                `position:absolute;top:0;bottom:0;left:${dc.s(m.apPaceLeft)};width:2px;background:var(--text-mid);opacity:0.45;z-index:2`,
              )}
            ></div>{' '}
            <div
              style={dc.css(
                `height:100%;width:100%;background:${dc.s(m.apProfitBar)};transform:scaleX(${dc.s(m.apProfitScale)});transform-origin:left center;transition:transform 260ms var(--ease-out)`,
              )}
            ></div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: '9.5px',
              color: 'var(--muted2)',
              marginTop: '6px',
            }}
          >
            <span>Day 0</span>
            <span>▲ Expected pace</span>
            <span>{dc.t(m.apDayEnd)}</span>
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,170px),1fr))',
          gap: '12px',
        }}
      >
        {' '}
        {(m.apStats ?? []).map((s, i146) => (
          <Fragment key={i146}>
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                <i className={`ph ${dc.s(s?.icon)}`} style={{ fontSize: '12px' }}></i>
                {dc.t(s?.label)}
              </div>
              <div
                style={dc.css(
                  `font-size:17px;font-weight:600;letter-spacing:-0.02em;color:${dc.s(s?.c)};margin-top:5px;font-variant-numeric:tabular-nums`,
                )}
              >
                {dc.t(s?.value)}
              </div>
              <div
                style={{
                  fontSize: '10px',
                  color: 'var(--muted2)',
                  marginTop: '2px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(s?.sub)}
              </div>
            </div>{' '}
          </Fragment>
        ))}{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,330px),1fr))',
          gap: '14px',
          alignItems: 'stretch',
        }}
      >
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '12.5px',
              fontWeight: '600',
            }}
          >
            <i className="ph ph-shield" style={{ fontSize: '14px', color: 'var(--vio)' }}></i>Drawdown Status
          </div>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'stretch',
              gap: '14px',
              marginTop: '16px',
              flex: '1',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <div style={{ flex: '1', minWidth: '0', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {' '}
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                Daily DD
              </div>{' '}
              <div style={{ position: 'relative', width: '100%', maxWidth: '200px', alignSelf: 'center' }}>
                {' '}
                <svg
                  role="img"
                  aria-label={`Daily DD ${dc.s(m.apDailyGauge?.label)} of limit`}
                  viewBox="0 0 200 114"
                  style={{ width: '100%', display: 'block' }}
                >
                  {' '}
                  {(m.apDailyGauge?.ticks ?? []).map((k, i147) => (
                    <Fragment key={i147}>
                      {' '}
                      <line
                        x1={dc.a(k?.x1)}
                        y1={dc.a(k?.y1)}
                        x2={dc.a(k?.x2)}
                        y2={dc.a(k?.y2)}
                        stroke={dc.a(k?.col)}
                        strokeWidth={dc.a(k?.w)}
                        strokeLinecap="round"
                        opacity={dc.a(k?.op)}
                      ></line>{' '}
                    </Fragment>
                  ))}{' '}
                </svg>{' '}
                <div
                  style={{
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    bottom: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1px',
                    pointerEvents: 'none',
                  }}
                >
                  {' '}
                  <span
                    style={dc.css(
                      `font-size:25px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;line-height:1;color:${dc.s(m.apDailyGauge?.col)}`,
                    )}
                  >
                    {dc.t(m.apDailyGauge?.label)}
                  </span>{' '}
                  <span
                    style={{ fontSize: '9.5px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(m.apDailySub)}
                  </span>{' '}
                </div>{' '}
                <span
                  style={{
                    position: 'absolute',
                    left: '1px',
                    bottom: '1px',
                    fontSize: '9px',
                    color: 'var(--faint)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  0%
                </span>{' '}
                <span
                  style={{
                    position: 'absolute',
                    right: '1px',
                    bottom: '1px',
                    fontSize: '9px',
                    color: 'var(--faint)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  100%
                </span>{' '}
              </div>{' '}
              <div
                style={dc.css(
                  `font-size:11px;font-weight:500;color:${dc.s(m.apDailyRemFg)};text-align:center;font-variant-numeric:tabular-nums`,
                )}
              >
                {dc.t(m.apDailyRemaining)}
              </div>{' '}
            </div>{' '}
            <div style={{ width: '1px', background: 'var(--l7)', flex: 'none' }}></div>{' '}
            <div style={{ flex: '1', minWidth: '0', display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {' '}
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                  textAlign: 'center',
                }}
              >
                Total DD
              </div>{' '}
              <div style={{ position: 'relative', width: '100%', maxWidth: '200px', alignSelf: 'center' }}>
                {' '}
                <svg
                  role="img"
                  aria-label={`Total DD ${dc.s(m.apTotalGauge?.label)} of limit`}
                  viewBox="0 0 200 114"
                  style={{ width: '100%', display: 'block' }}
                >
                  {' '}
                  {(m.apTotalGauge?.ticks ?? []).map((k, i148) => (
                    <Fragment key={i148}>
                      {' '}
                      <line
                        x1={dc.a(k?.x1)}
                        y1={dc.a(k?.y1)}
                        x2={dc.a(k?.x2)}
                        y2={dc.a(k?.y2)}
                        stroke={dc.a(k?.col)}
                        strokeWidth={dc.a(k?.w)}
                        strokeLinecap="round"
                        opacity={dc.a(k?.op)}
                      ></line>{' '}
                    </Fragment>
                  ))}{' '}
                </svg>{' '}
                <div
                  style={{
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    bottom: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1px',
                    pointerEvents: 'none',
                  }}
                >
                  {' '}
                  <span
                    style={dc.css(
                      `font-size:25px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;line-height:1;color:${dc.s(m.apTotalGauge?.col)}`,
                    )}
                  >
                    {dc.t(m.apTotalGauge?.label)}
                  </span>{' '}
                  <span
                    style={{ fontSize: '9.5px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}
                  >
                    {dc.t(m.apTotalSub)}
                  </span>{' '}
                </div>{' '}
                <span
                  style={{
                    position: 'absolute',
                    left: '1px',
                    bottom: '1px',
                    fontSize: '9px',
                    color: 'var(--faint)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  0%
                </span>{' '}
                <span
                  style={{
                    position: 'absolute',
                    right: '1px',
                    bottom: '1px',
                    fontSize: '9px',
                    color: 'var(--faint)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  100%
                </span>{' '}
              </div>{' '}
              <div
                style={dc.css(
                  `font-size:11px;font-weight:500;color:${dc.s(m.apTotalRemFg)};text-align:center;font-variant-numeric:tabular-nums`,
                )}
              >
                {dc.t(m.apTotalRemaining)}
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3,minmax(0,1fr))',
              gap: '8px',
              marginTop: '16px',
              paddingTop: '12px',
              borderTop: '1px solid var(--l6)',
              flex: 'none',
            }}
          >
            {' '}
            {(m.apZones ?? []).map((z, i149) => (
              <Fragment key={i149}>
                {' '}
                <div style={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                  <span
                    style={dc.css(
                      `width:8px;height:8px;border-radius:50%;background:${dc.s(z?.c)};flex:none`,
                    )}
                  ></span>
                  <div>
                    <div style={dc.css(`font-size:10px;font-weight:500;color:${dc.s(z?.c)}`)}>
                      {dc.t(z?.label)}
                    </div>
                    <div
                      style={{ fontSize: '9px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}
                    >
                      {dc.t(z?.range)}
                    </div>
                  </div>
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            padding: '16px 18px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              fontSize: '12.5px',
              fontWeight: '600',
            }}
          >
            <i className="ph ph-check-circle" style={{ fontSize: '14px', color: 'var(--pos)' }}></i>Rule
            Compliance
          </div>{' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '9px',
              marginTop: '14px',
              flex: '1',
              justifyContent: 'space-between',
            }}
          >
            {' '}
            {(m.apRules ?? []).map((r, i150) => (
              <Fragment key={i150}>
                {' '}
                <div
                  style={dc.css(
                    `display:flex;align-items:center;gap:11px;padding:11px 13px;border-radius:11px;border:1px solid ${dc.s(r?.bd)};background:${dc.s(r?.bg)}`,
                  )}
                >
                  {' '}
                  <i
                    className={`ph ${dc.s(r?.icon)}`}
                    style={dc.css(`font-size:15px;color:${dc.s(r?.fg)};flex:none`)}
                  ></i>{' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    <div style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(r?.label)}</div>
                    <div
                      style={{
                        fontSize: '10.5px',
                        color: 'var(--muted2)',
                        marginTop: '2px',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(r?.detail)}
                    </div>
                  </div>{' '}
                  <span
                    style={dc.css(
                      `display:inline-flex;align-items:center;gap:5px;font-size:9.5px;font-weight:600;padding:2px 9px;border-radius:99px;border:1px solid ${dc.s(r?.bd)};color:${dc.s(r?.fg)};flex:none`,
                    )}
                  >
                    <i className={`ph ${dc.s(r?.statusIcon)}`} style={{ fontSize: '10px' }}></i>
                    {dc.t(r?.statusLabel)}
                  </span>{' '}
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className="ph ph-trend-up" style={{ fontSize: '14px', color: 'var(--pos)' }}></i>
          <span style={{ fontSize: '12.5px', fontWeight: '600' }}>Equity Trajectory</span>
          <div style={{ flex: '1' }}></div>
          <span style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
            {dc.t(m.apEqCount)}
          </span>
        </div>{' '}
        <svg
          viewBox="0 0 420 74"
          preserveAspectRatio="none"
          style={{ width: '100%', height: '120px', marginTop: '12px' }}
        >
          {' '}
          <defs>
            <linearGradient id="apg" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="var(--pos)" stopOpacity="0.18"></stop>
              <stop offset="1" stopColor="var(--pos)" stopOpacity="0"></stop>
            </linearGradient>
          </defs>{' '}
          <path d={dc.a(m.apEqFill)} fill="url(#apg)"></path>{' '}
          <path
            d={dc.a(m.apEqPath)}
            fill="none"
            stroke={dc.a(m.apEqStroke)}
            strokeWidth="1.6"
            vectorEffect="non-scaling-stroke"
          ></path>{' '}
        </svg>{' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: '10.5px',
            color: 'var(--muted2)',
            marginTop: '8px',
            paddingTop: '9px',
            borderTop: '1px solid var(--l6)',
            flexWrap: 'wrap',
            gap: '8px',
          }}
        >
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.apEqStart)}</span>
          <span>— Starting balance</span>
          <span style={{ fontVariantNumeric: 'tabular-nums' }}>{dc.t(m.apEqCurrent)}</span>
        </div>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          borderLeft: '3px solid var(--vio)',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '12.5px',
            fontWeight: '600',
            color: 'var(--vio)',
          }}
        >
          <i className="ph-fill ph-sparkle" style={{ fontSize: '14px' }}></i>AI Predictive Success Score
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,200px),1fr))',
            gap: '18px',
            marginTop: '14px',
            alignItems: 'start',
          }}
        >
          {' '}
          <div
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}
          >
            {' '}
            <div style={{ position: 'relative', width: '100%', maxWidth: '210px' }}>
              {' '}
              <svg
                role="img"
                aria-label={`Predictive success score ${dc.s(m.apScore)} of 100`}
                viewBox="0 0 200 114"
                style={{ width: '100%', display: 'block' }}
              >
                {' '}
                {(m.apScoreTicks ?? []).map((k, i151) => (
                  <Fragment key={i151}>
                    {' '}
                    <line
                      x1={dc.a(k?.x1)}
                      y1={dc.a(k?.y1)}
                      x2={dc.a(k?.x2)}
                      y2={dc.a(k?.y2)}
                      stroke={dc.a(k?.col)}
                      strokeWidth={dc.a(k?.w)}
                      strokeLinecap="round"
                      opacity={dc.a(k?.op)}
                    ></line>{' '}
                  </Fragment>
                ))}{' '}
              </svg>{' '}
              <div
                style={{
                  position: 'absolute',
                  left: '0',
                  right: '0',
                  bottom: '6px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '2px',
                  pointerEvents: 'none',
                }}
              >
                {' '}
                <span
                  style={dc.css(
                    `font-size:29px;font-weight:600;letter-spacing:-0.02em;line-height:1;color:${dc.s(m.apScoreFg)};font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.apScore)}
                </span>{' '}
                <span
                  style={dc.css(
                    `font-size:9.5px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:${dc.s(m.apScoreFg)}`,
                  )}
                >
                  {dc.t(m.apScoreLabel)}
                </span>{' '}
                <span
                  style={{ fontSize: '9.5px', color: 'var(--muted)', fontVariantNumeric: 'tabular-nums' }}
                >
                  {dc.t(m.apConfidence)}
                </span>{' '}
              </div>{' '}
              <span
                style={{
                  position: 'absolute',
                  left: '1px',
                  bottom: '1px',
                  fontSize: '9px',
                  color: 'var(--faint)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                0
              </span>{' '}
              <span
                style={{
                  position: 'absolute',
                  right: '1px',
                  bottom: '1px',
                  fontSize: '9px',
                  color: 'var(--faint)',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                100
              </span>{' '}
            </div>{' '}
            {m.apLowSample ? (
              <>
                {' '}
                <div
                  style={{
                    fontSize: '10px',
                    color: 'var(--amb-2)',
                    lineHeight: '1.5',
                    marginTop: '8px',
                    padding: '6px 9px',
                    borderRadius: '8px',
                    border: '1px solid color-mix(in srgb, var(--amb) 20%, transparent)',
                    background: 'color-mix(in srgb, var(--amb) 8%, transparent)',
                    maxWidth: '150px',
                  }}
                >
                  {dc.t(m.apLowSampleNote)}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
          <div style={{ gridColumn: 'span 2', minWidth: '0' }}>
            {' '}
            <div style={{ fontSize: '11.5px', color: 'var(--muted)', lineHeight: '1.65', maxWidth: '84ch' }}>
              {dc.t(m.apSummary)}
            </div>{' '}
            <div
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                marginTop: '14px',
              }}
            >
              Projected Target Date
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', marginTop: '4px' }}>
              <span style={{ fontSize: '17px', fontWeight: '600', letterSpacing: '-0.01em' }}>
                {dc.t(m.apProjected)}
              </span>
              <span style={{ fontSize: '10px', color: 'var(--muted2)', paddingBottom: '2px' }}>
                (base case)
              </span>
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '14px',
                marginTop: '6px',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              {m.apHasBest ? (
                <span style={{ fontSize: '11px', color: 'var(--pos)' }}>{dc.t(m.apBestDate)}</span>
              ) : null}{' '}
              {m.apHasWorstDate ? (
                <span style={{ fontSize: '11px', color: 'var(--amb-2)' }}>{dc.t(m.apWorstDate)}</span>
              ) : null}{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,280px),1fr))',
            gap: '16px',
            marginTop: '16px',
          }}
        >
          {' '}
          <div>
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                fontWeight: '600',
                color: 'var(--pos)',
              }}
            >
              <i className="ph ph-star" style={{ fontSize: '11px' }}></i>Strengths
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '8px' }}>
              {' '}
              {(m.apStrengths ?? []).map((s, i152) => (
                <Fragment key={i152}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '7px',
                      fontSize: '11.5px',
                      color: 'var(--text2)',
                      lineHeight: '1.55',
                    }}
                  >
                    <i
                      className="ph ph-check-circle"
                      style={{ fontSize: '12px', color: 'var(--pos)', flex: 'none', marginTop: '2px' }}
                    ></i>
                    {dc.t(s?.t)}
                  </div>
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          <div>
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                fontWeight: '600',
                color: 'var(--amb-2)',
              }}
            >
              <i className="ph ph-warning" style={{ fontSize: '11px' }}></i>Process Gaps
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px', marginTop: '8px' }}>
              {' '}
              {(m.apRisks ?? []).map((r, i153) => (
                <Fragment key={i153}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '7px',
                      fontSize: '11.5px',
                      color: 'var(--text2)',
                      lineHeight: '1.55',
                    }}
                  >
                    <i
                      className="ph ph-x-circle"
                      style={{ fontSize: '12px', color: 'var(--neg)', flex: 'none', marginTop: '2px' }}
                    ></i>
                    {dc.t(r?.t)}
                  </div>
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit,minmax(min(50%,110px),1fr))',
            gap: '10px',
            marginTop: '16px',
            paddingTop: '13px',
            borderTop: '1px solid var(--l6)',
          }}
        >
          {' '}
          {(m.apKeyMetrics ?? []).map((k, i154) => (
            <Fragment key={i154}>
              {' '}
              <div style={{ textAlign: 'center' }}>
                <div
                  style={dc.css(
                    `font-size:12px;font-weight:600;color:${dc.s(k?.c)};font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(k?.value)}
                </div>
                <div style={{ fontSize: '9.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                  {dc.t(k?.label)}
                </div>
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
        <div style={{ marginTop: '16px', paddingTop: '13px', borderTop: '1px solid var(--l6)' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
            <span
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
              }}
            >
              Score History
            </span>
            <div style={{ flex: '1' }}></div>
            <span
              style={dc.css(
                `font-size:10px;color:${dc.s(m.apScoreHistory?.deltaFg)};font-variant-numeric:tabular-nums`,
              )}
            >
              {dc.t(m.apScoreHistory?.delta)}
            </span>
          </div>{' '}
          <svg
            viewBox="0 0 300 34"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '44px', marginTop: '8px' }}
          >
            <path
              d={dc.a(m.apScoreHistory?.path)}
              fill="none"
              stroke={dc.a(m.apScoreHistory?.stroke)}
              strokeWidth="1.6"
              vectorEffect="non-scaling-stroke"
            ></path>
          </svg>{' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              fontSize: '9.5px',
              color: 'var(--muted2)',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            <span>{dc.t(m.apScoreHistory?.lo)}</span>
            <span>{dc.t(m.apScoreHistory?.span)}</span>
            <span>{dc.t(m.apScoreHistory?.hi)}</span>
          </div>{' '}
        </div>{' '}
        <button
          className="scp-d2b1f07"
          onClick={m.apImproveToggle}
          aria-label="Improve my score"
          aria-expanded={dc.b(m.apImproveOpen)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '9px',
            width: '100%',
            marginTop: '14px',
            padding: '10px 14px',
            borderRadius: '11px',
            border: '1px solid color-mix(in srgb, var(--vio) 25%, transparent)',
            background: 'color-mix(in srgb, var(--vio) 10%, transparent)',
            color: 'var(--vio)',
            fontSize: '12px',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-brain" style={{ fontSize: '14px' }}></i>
          <span style={{ flex: '1', textAlign: 'left' }}>Improve My Score</span>
          <i className={`ph ${dc.s(m.apImproveIcon)}`} style={{ fontSize: '13px' }}></i>
        </button>{' '}
        {m.apImproveOpen ? (
          <>
            {' '}
            <div style={{ marginTop: '12px' }}>
              {' '}
              <div
                style={{
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  color: 'var(--vio)',
                }}
              >
                Personalised Recommendations
              </div>{' '}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
                {' '}
                {(m.apImprovements ?? []).map((i, i155) => (
                  <Fragment key={i155}>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px',
                        padding: '10px 12px',
                        border: '1px solid var(--l8)',
                        borderRadius: '11px',
                        background: 'var(--l3)',
                      }}
                    >
                      <span
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '50%',
                          background: 'color-mix(in srgb, var(--vio) 20%, transparent)',
                          color: 'var(--vio)',
                          fontSize: '10px',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flex: 'none',
                        }}
                      >
                        {dc.t(i?.n)}
                      </span>
                      <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.55' }}>
                        {dc.t(i?.t)}
                      </span>
                    </div>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {' '}
          <span
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Daily P&L — Last 30 Days
          </span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '10px',
              color: 'var(--muted2)',
            }}
          >
            <span
              style={{ width: '9px', height: '9px', borderRadius: '2px', background: 'var(--pos)' }}
            ></span>
            Profit
          </span>{' '}
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '10px',
              color: 'var(--muted2)',
            }}
          >
            <span
              style={{ width: '9px', height: '9px', borderRadius: '2px', background: 'var(--neg)' }}
            ></span>
            Loss
          </span>{' '}
        </div>{' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(10,minmax(0,1fr))',
            gap: '5px',
            marginTop: '12px',
          }}
        >
          {' '}
          {(m.apCells ?? []).map((c, i156) => (
            <Fragment key={i156}>
              <div
                title={dc.a(c?.title)}
                style={dc.css(`height:26px;border-radius:4px;background:${dc.s(c?.bg)}`)}
              ></div>
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>{' '}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
          gap: '14px',
        }}
      >
        {' '}
        {m.apHasBestTrade ? (
          <>
            {' '}
            <div
              style={{
                border: '1px solid color-mix(in srgb, var(--pos) 20%, transparent)',
                background: 'color-mix(in srgb, var(--pos) 7%, transparent)',
                borderRadius: '16px',
                padding: '14px 16px',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  color: 'var(--pos)',
                }}
              >
                <i className="ph ph-trend-up" style={{ fontSize: '12px' }}></i>Best Trade
              </div>{' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '9px' }}>
                <div style={{ flex: '1', minWidth: '0' }}>
                  <div style={{ fontSize: '12.5px', fontWeight: '700' }}>{dc.t(m.apBest?.sym)}</div>
                  <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                    {dc.t(m.apBest?.meta)}
                  </div>
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: 'var(--pos)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.apBest?.pnl)}
                </span>
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.apHasWorstTrade ? (
          <>
            {' '}
            <div
              style={{
                border: '1px solid color-mix(in srgb, var(--neg) 20%, transparent)',
                background: 'color-mix(in srgb, var(--neg-fill) 7%, transparent)',
                borderRadius: '16px',
                padding: '14px 16px',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  color: 'var(--neg)',
                }}
              >
                <i className="ph ph-trend-down" style={{ fontSize: '12px' }}></i>Worst Trade
              </div>{' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '9px' }}>
                <div style={{ flex: '1', minWidth: '0' }}>
                  <div style={{ fontSize: '12.5px', fontWeight: '700' }}>{dc.t(m.apWorst?.sym)}</div>
                  <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                    {dc.t(m.apWorst?.meta)}
                  </div>
                </div>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: 'var(--neg)',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.apWorst?.pnl)}
                </span>
              </div>{' '}
            </div>{' '}
          </>
        ) : null}{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          padding: '16px 18px',
        }}
      >
        {' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <i className="ph ph-activity" style={{ fontSize: '14px', color: 'var(--sky)' }}></i>
          <span style={{ fontSize: '12.5px', fontWeight: '600' }}>Challenge Trade Log</span>
          <div style={{ flex: '1' }}></div>
          <span style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
            {dc.t(m.apLogCount)}
          </span>
        </div>{' '}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
            marginTop: '11px',
            maxHeight: '260px',
            overflowY: 'auto',
          }}
        >
          {' '}
          {(m.apLog ?? []).map((t, i157) => (
            <Fragment key={i157}>
              {' '}
              <div
                className="scp-4f3e86a"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '11px',
                  padding: '6px 8px',
                  borderRadius: '8px',
                }}
              >
                {' '}
                <span
                  style={dc.css(
                    `width:6px;height:6px;border-radius:50%;background:${dc.s(t?.dot)};flex:none`,
                  )}
                ></span>{' '}
                <span
                  style={{
                    fontSize: '11px',
                    color: 'var(--muted2)',
                    width: '52px',
                    flex: 'none',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(t?.date)}
                </span>{' '}
                <span style={{ fontSize: '11px', fontWeight: '500', width: '66px', flex: 'none' }}>
                  {dc.t(t?.sym)}
                </span>{' '}
                <span
                  style={dc.css(
                    `font-size:9px;font-weight:600;padding:2px 7px;border-radius:5px;background:${dc.s(t?.dirBg)};color:${dc.s(t?.dirFg)};flex:none`,
                  )}
                >
                  {dc.t(t?.dir)}
                </span>{' '}
                <span
                  style={{
                    fontSize: '11px',
                    color: 'var(--muted2)',
                    flex: 'none',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(t?.lots)}
                </span>{' '}
                <div style={{ flex: '1' }}></div>{' '}
                <span
                  style={dc.css(
                    `font-size:11px;font-weight:600;color:${dc.s(t?.netFg)};flex:none;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(t?.net)}
                </span>{' '}
              </div>{' '}
            </Fragment>
          ))}{' '}
        </div>{' '}
      </div>
    </div>
  );
}
